import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Pagination, Row, Select, Space, Table, Tooltip } from 'antd';

const AccountTablePanel = ({
  form,
  onFilterFinish,
  onSearch,
  platformOptions,
  accountCreateBlock,
  accountQuotaTooltip,
  onCreate,
  columns,
  dataSource,
  loading,
  selectedAccountKeys,
  onTableSelectionChange,
  isAllCurrentPageSelected,
  onToggleSelectAllCurrentPage,
  onBatchDelete,
  onClearSelection,
  pagination,
  onPageChange,
  onPageSizeChange,
}) => (
  <Card className="page-card" bodyStyle={{ padding: 0 }}>
    <div className="page-panel">
      <div className="page-panel__top">
        <Form
          form={form}
          layout="horizontal"
          onFinish={onFilterFinish}
          style={{ marginBottom: 0 }}
        >
          <Row gutter={[16, 16]} justify="space-between">
            <Col span={18}>
              <Row gutter={[16, 16]}>
                <Col span={6}>
                  <Form.Item label="关键词" name="keyword" style={{ marginBottom: 0 }}>
                    <Input placeholder="搜索账号名称" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="平台" name="platforms" style={{ marginBottom: 0 }}>
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: '100%' }}
                      placeholder="请选择平台"
                      options={platformOptions}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="状态" name="status" style={{ marginBottom: 0 }}>
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: '100%' }}
                      placeholder="请选择状态"
                      options={[
                        { label: '活跃', value: 'active' },
                        { label: '已暂停', value: 'paused' },
                        { label: '未激活', value: 'inactive' },
                        { label: '已停用', value: 'suspended' },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="运营人ID" name="operator_user_id" style={{ marginBottom: 0 }}>
                    <Input placeholder="匹配 operator_user_ids" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col span={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <Space size="small" style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Button type="primary" style={{ width: 80 }} onClick={onSearch}>
                  检索
                </Button>
                <Tooltip title={accountCreateBlock.blocked ? accountQuotaTooltip : null}>
                  <span>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={onCreate}
                      disabled={accountCreateBlock.blocked}
                    >
                      新增账号
                    </Button>
                  </span>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>

      <div className="page-panel__body">
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey="account_id"
          loading={loading}
          scroll={{ x: 2800 }}
          rowSelection={{
            selectedRowKeys: selectedAccountKeys,
            onChange: onTableSelectionChange,
          }}
          pagination={false}
        />
      </div>

      <div
        className="page-panel__bottom"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 16px 0',
          background: '#fff',
        }}
      >
        <div>
          {selectedAccountKeys.length > 0 && (
            <Space>
              <Button onClick={onToggleSelectAllCurrentPage}>
                {isAllCurrentPageSelected ? '取消全选(本页)' : '全选本页'}
              </Button>
              <span>已选择 {selectedAccountKeys.length} 项</span>
              <Button danger icon={<DeleteOutlined />} onClick={onBatchDelete}>
                批量删除
              </Button>
              <Button onClick={onClearSelection}>清空全部</Button>
            </Space>
          )}
        </div>
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          showTotal={(total) => `共 ${total} 条记录`}
          showSizeChanger
          showQuickJumper
          style={{ margin: 0 }}
          onChange={onPageChange}
          onShowSizeChange={onPageSizeChange}
        />
      </div>
    </div>
  </Card>
);

export default AccountTablePanel;
